/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type TrashedDirectLinkType from '@jira/portfolio-3__plan-trashed-direct-link/src/ui/index.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyTrashedPlanDirectLink: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof TrashedDirectLinkType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-plan-trashed-direct-link", jiraSpaEntry: "async-plan-trashed-direct-link" */ '@jira/portfolio-3__plan-trashed-direct-link/src/index.tsx'
		),
	),
);

export const TrashedPlanDirectLink = (): React.JSX.Element => (
	<LazyPage
		Page={LazyTrashedPlanDirectLink}
		pageId="trashed-plan-direct-link"
		shouldShowSpinner={false}
	/>
);
